import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import api from "@/lib/api";
import SEO from "@/components/SEO";
import PageHero from "@/components/site/PageHero";
import { ServiceCard } from "@/components/site/cards";
import { ContactCTA } from "@/pages/Home";
import { stagger, fadeUp, viewportOnce } from "@/lib/motion";

export default function Services() {
  const [services, setServices] = useState([]);
  useEffect(() => {
    api.get("/services").then((r) => setServices(r.data)).catch(() => {});
  }, []);

  const categories = [...new Set(services.map((s) => s.category))];

  return (
    <>
      <SEO title="Services" description="Explore Web Vantage services: website & app development, ecommerce, AI automation, SEO, branding, UI/UX, cloud and more." path="/services" />
      <PageHero
        overline="Services"
        title="Everything you need to build and grow"
        subtitle="Fourteen deep capabilities under one roof — so you get a single, accountable partner from strategy to scale."
        crumbs={[{ label: "Services" }]}
      />
      <section className="py-20 lg:py-28">
        <div className="container-wv space-y-16">
          {categories.map((cat) => (
            <div key={cat}>
              <div className="mb-8 flex items-center gap-4">
                <h2 className="font-heading text-2xl font-semibold text-white">{cat}</h2>
                <div className="h-px flex-1 bg-white/10" />
              </div>
              <motion.div variants={stagger(0.06)} initial="hidden" whileInView="show" viewport={viewportOnce} className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
                {services.filter((s) => s.category === cat).map((s, i) => (
                  <motion.div key={s.id} variants={fadeUp}><ServiceCard service={s} index={i} /></motion.div>
                ))}
              </motion.div>
            </div>
          ))}
        </div>
      </section>
      <ContactCTA />
    </>
  );
}
